export default "__VITE_ASSET__DQn$wxTB__"